import React, { useRef, useEffect, useState } from 'react';
import './styles.css';
import patternDesktop from './assets/pattern-divider-desktop.svg';
import patternMobile from './assets/pattern-divider-mobile.svg';
import dice from './assets/icon-dice.svg';

const App = () => {
  const [quote, setQuote] = useState("It is easy to sit up and take notice, what's difficult is getting up and taking action.");
  const [id, setId] = useState("143");
  const windowSize = useRef([window.innerWidth]);
  var DataisLoaded = false;
  var items = [];

  const GetAdvice = () => {
    return(
      fetch("https://api.adviceslip.com/advice")
          .then((res) => res.json())
          .then((json) => {
            items = json;
            setQuote(items.slip.advice);
            setId(items.slip.id);
            DataisLoaded = true;
          })
      )
  };
  useEffect(() => {
    GetAdvice();
  }, []);
  
  

  if(DataisLoaded) return <h1>Please wait some time</h1>
  return (
    <div className='bg-app-bg flex flex-col justify-center items-center h-screen'>
      <div className='bg-app-card h-2/5 w-11/12 rounded-xl flex flex-col justify-center items-center sm:w-1/3'>
        <p className='text-green font-manrope -mt-30 mb-3 text-sm font-lighter uppercase tracking-widest'>Advice #{id}</p>
        <h2 className='font-manrope text-cyan text-2xl mb-3 text-center w-full sm:text-3xl'><q>{quote}</q></h2>
        {windowSize.current[0] > 375 ? <img src={patternDesktop} alt="pattern" /> : <img src={patternMobile} alt="pattern"/>}
        <button onClick={GetAdvice} className='mt-10 bg-green flex justify-center items-center w-10 h-10 rounded-3xl hover:shadow-lg'>
          <img src={dice} alt="btn"/>
        </button>
      </div>
    </div>
  )
}




export default App